import { saveAs } from 'file-saver';
import { showToast } from './toast';

const form = document.querySelector<HTMLFormElement>('#salesFilterForm');
const extractButton = document.querySelector<HTMLButtonElement>('#btnExtractList');
if (form && extractButton) {
    const extractRequest = async (data) => {
        extractButton.classList.toggle("is-loading", true);
        // fetch
        try {
            let response = await fetch(
                `/api/sales/extract-list`,
                {
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    method: 'post',
                    body: JSON.stringify(data)
                }
            );

            let header = response.headers.get("content-disposition");
            let filename = header.match("\"(.*)\"")[1];
            if (!filename) {
                filename = 'extract-sales.csv';
            }
            filename = filename.replace(/[^a-z0-9.-]/gi, '_');

            // save file
            saveAs(await response.blob(), filename);
        } catch (e) {
            showToast('danger', "Oops! Something went wrong!");
        }
        extractButton.classList.toggle("is-loading", false);
    }

    extractButton.addEventListener("click", (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        // List key/value pairs
        var object = { list: form.dataset['list'] };
        formData.forEach((value, key) => {
            if (value === '') {
                return;
            }
            // Reflect.has in favor of: object.hasOwnProperty(key)
            if (!Reflect.has(object, key)) {
                // if value from multiple <select> convert into array
                const element = form.querySelector(`input[name="${key}"], select[name="${key}"]`);
                if (element.tagName === 'SELECT' && element.hasAttribute("multiple")) {
                    object[key] = [value];
                } else if (element.getAttribute("type") === "number") {
                    object[key] = new Number(value);
                } else {
                    object[key] = value;
                }

                return;
            }

            if (!Array.isArray(object[key])) {
                object[key] = [object[key]];
            }

            object[key].push(value);
        });
        extractRequest(object);
    });
}



export default undefined;